<button pButton appRipple type="button" icon="fa fa-download"
    [label]="'label_download_userguidline' | translate" (click)="onDownloadGuidFile()"></button>
<button pButton appRipple type="button" icon="fa fa-download" [label]="'label_download_template' | translate" (click)="onDownloadFile()"></button>
<button pButton appRipple type="button" icon="fa fa-upload" [label]="labelBulkImport" (click)="showBulkImportPopup(labelBulkImport)"></button>

<p-dialog modal="true" position="center" [style]="{width: '670px'}" (onHide)="Cancel()" ng-style="overflow: auto" class="bulk-import-dialog"
  [(visible)]="displayImportBulkImportPopup" [contentStyle]="{'overflow':'auto'}" modal="true">

  <ng-template pTemplate="header" translate> {{'label_bulk_import' | translate}}</ng-template>

  <div class="col-12" style="min-height: 100px;">
    <div class="Rectangle-Copy-3 round-note"></div>
    <div class="center-text">Use Upload Button</div>
    <div class="center-text1">{{uploadedFileName}}</div>
  </div>
  <div class="col-12">
    <button class="negative-button ml-3" pButton appRipple type="button" (click)="Cancel()" [label]="labelCancel"
      style="float: right;margin-top: 15px;"></button>
    <app-file-uploader style="float:right;" class="round-note mar-7" (onFileUpload)="onUploadProfile($event)"
      [uploadButtonLabel]="'label_upload' | translate" accept=".xlsx,xls"></app-file-uploader>
  </div>
</p-dialog>
